

























































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyCommon from "@/mixins/common";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyCommon) {}
